//! Represents viewport configuration
export const VIEWS_START_CONFIG: any = {
  d3View: {
    offset: { x: 0, y: 0 },
    size: { x: 1, y: 1 },
    isActive: true,
    rotation: true,
    objects: [],
  },
};

export const d3ViewTools = ['rotation', 'pan', 'zoom', null] as const;
export type d3ViewToolsType = typeof d3ViewTools[number];
